<div class="empty-space"></div>
<div class="jobs" [dir]="'Direction' | translate">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
        <div class="container" [dir]="'Direction' | translate">
            <span class="section-title">{{ "TermsAndConditions.Title" | translate }}</span>
        </div>
        <div class="jobs-inner">
            <div class="terms-container">
                <div class="terms-content">
                    <p>{{ "TermsAndConditions.Content1" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content2" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content3" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content4" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content5" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content6" | translate }}</p>
                    <p>{{ "TermsAndConditions.Content7" | translate }}</p>
                    <hr/>
                </div>
            </div>
        </div>
    </div>
</div>
